export var InstanceAdditionalDataKey;
(function (InstanceAdditionalDataKey) {
    // Audience tasks
    InstanceAdditionalDataKey["AUDIENCE_ID"] = "AUDIENCE_ID";
    // Reservation service id
    InstanceAdditionalDataKey["SERVICE_ID"] = "SERVICE_ID";
    // Smart profiles tasks
    InstanceAdditionalDataKey["MERGE_SUGGESTION_REQUEST_ID"] = "MERGE_SUGGESTION_REQUEST_ID";
    // Smart data tasks
    InstanceAdditionalDataKey["PROFILE_ID"] = "PROFILE_ID";
    // Newsletter tasks
    InstanceAdditionalDataKey["API_KEY"] = "API_KEY";
    InstanceAdditionalDataKey["SAVED_NEWSLETTER_ACCOUNT_INFO"] = "SAVED_NEWSLETTER_ACCOUNT_INFO";
    InstanceAdditionalDataKey["ACCOUNT_CREATION_JOB_ID"] = "ACCOUNT_CREATION_JOB_ID";
})(InstanceAdditionalDataKey || (InstanceAdditionalDataKey = {}));
